/* eslint-disable import/prefer-default-export */
import { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { useStateMachine } from "little-state-machine";
import { useEffect, useRef } from "react";
import { updateBackgroundLoadingState } from "store/store";

export function useCustomQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
  const { state, actions }: any = useStateMachine({ updateBackgroundLoadingState });
  const backgroundLoaderValue = useRef<boolean>(state.showBackgroundLoader);

  useEffect(() => {
    backgroundLoaderValue.current = state.showBackgroundLoader;
  }, [state.showBackgroundLoader]);

  const fetchQueryFn: QueryFunction<TQueryFnData, TQueryKey> = (context) =>
    new Promise((resolve, reject) => {
      Promise.resolve(options?.queryFn?.(context))
        .then((res) => {
          resolve(res as TQueryFnData);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          if (backgroundLoaderValue.current) {
            actions.updateBackgroundLoadingState(false);
          }
        });
    });

  return useQuery({ ...options, ...(options.queryFn && { queryFn: fetchQueryFn }) });
}
